import { render } from "./AboutFeature.vue?vue&type=template&id=acb91d0e&scoped=true"
import script from "./AboutFeature.vue?vue&type=script&lang=js"
export * from "./AboutFeature.vue?vue&type=script&lang=js"

import "./AboutFeature.vue?vue&type=style&index=0&id=acb91d0e&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb91d0e"]])

export default __exports__